import { UPDATE_CLIENT_BALANCE } from "../constants/reduxConstants";


export const updateClientBalanceAction = (data) => {
  return {
    type: UPDATE_CLIENT_BALANCE,
    data: data,
  };
};